import React from 'react';
import { useAppSelector } from '../hooks/redux';
import MainLandingPage from './MainLandingPage';
import PreLaunchLandingPage from './PreLaunchLandingPage';

const LandingPage: React.FC = () => {
  const { user, isAuthenticated } = useAppSelector((state) => state.auth);

  // If user is authenticated, show the full platform landing page
  if (isAuthenticated) {
    return <MainLandingPage />;
  }

  // Show the main landing page always now that pre-launch is over
  return <MainLandingPage />;
};

export default LandingPage;
